import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import api from '../../lib/api';
import toast from 'react-hot-toast';

export default function RatingWidget({ ticketId, existingRating, onRated }) {
  const [rating, setRating]   = useState(existingRating || null);
  const [saving, setSaving]   = useState(false);

  async function rate(value) {
    if (saving) return;
    setSaving(true);
    try {
      await api.post(`/ratings/${ticketId}`, { rating: value });
      setRating(value);
      toast.success('Thanks for your feedback!');
      if (onRated) onRated(value);
    } catch (e) { toast.error(e.message); }
    finally { setSaving(false); }
  }

  if (rating) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
        <span style={{ color: 'var(--text-muted)' }}>Your rating:</span>
        {rating === 'thumbs_up'
          ? <span style={{ color: '#10b981', display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600 }}><ThumbsUp size={14} /> Good</span>
          : <span style={{ color: '#ef4444', display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600 }}><ThumbsDown size={14} /> Not great</span>
        }
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>How did we do?</span>
      <button
        onClick={() => rate('thumbs_up')}
        disabled={saving}
        style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '5px 12px', borderRadius: 6, border: '1px solid #10b981', background: 'none', color: '#10b981', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
      >
        <ThumbsUp size={13} /> Good
      </button>
      <button
        onClick={() => rate('thumbs_down')}
        disabled={saving}
        style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '5px 12px', borderRadius: 6, border: '1px solid #ef4444', background: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
      >
        <ThumbsDown size={13} /> Not great
      </button>
    </div>
  );
}
